<template>
    <v-container>
        <v-card v-if="loggedIn && showForm">
            <v-card-title class="yellow white--text">My Account</v-card-title>
            <v-card-text class="mt-5">
                <v-form
                        :lazy-validation="false"
                        ref="form"
                        v-model="formValid"
                >
                    <v-text-field
                            id="name-field"
                            label="Name"
                            disabled
                            v-model="accountData.name"
                    ></v-text-field>

                    <v-text-field
                            id="username-field"
                            label="Username"
                            disabled
                            v-model="accountData.username"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.email"
                            @keydown="keyDownHandler"
                            id="email-field"
                            label="E-mail"
                            required
                            v-model="accountData.email"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.mobile"
                            @keydown="keyDownHandler"
                            id="mobile-field"
                            label="Mobile #"
                            required
                            v-model="accountData.mobile"
                    ></v-text-field>                    

                    <v-text-field
                            :rules="formRules.city"
                            @keydown="keyDownHandler"
                            id="city-field"
                            label="City"
                            required
                            v-model="accountData.city"
                    ></v-text-field>

                    <v-select
                            :rules="formRules.state"
                            :items="statesOptions"
                            item-text="name"
                            item-value="code"
                            label="State"
                            persistent-hint
                            single-line                            
                            required
                            v-model="accountData.state"
                    ></v-select>                

                    <v-text-field
                            :rules="formRules.zipCode"
                            @keydown="keyDownHandler"
                            id="zip-field"
                            label="Zip Code"
                            required
                            v-model="accountData.zipCode"
                    ></v-text-field>

                    <div v-if="showChangePassword">
                        <v-text-field
                                :rules="formRules.oldPassword"
                                @keydown="keyDownHandler"
                                label="Current Password"
                                required
                                type="password"
                                v-model="accountData.oldPassword"
                        ></v-text-field>

                        <v-text-field
                                :rules="formRules.newPassword"
                                @keydown="keyDownHandler"
                                label="New Password"
                                required
                                type="password"
                                v-model="accountData.newPassword"
                        ></v-text-field>

                        <v-text-field
                                :rules="formRules.passwordConfirm"
                                @keydown="keyDownHandler"
                                label="Confirm Password"
                                required
                                type="password"
                                v-model="accountData.passwordConfirmation"
                        ></v-text-field>
                    </div>

                    <v-container class="mt-2">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-btn
                                        :disabled="!formValid || executing"
                                        @click="update"
                                        class="mr-4 white--text"
                                        color="green"
                                >
                                    Update
                                </v-btn>

                                <v-btn v-show="!showChangePassword"
                                        :disabled="executing"
                                        @click="toggleShowChangePassword"
                                        class="mr-4 white--text"
                                        color="green"
                                >
                                    Change Password
                                </v-btn>

                                <v-btn v-show="showChangePassword"
                                        :disabled="executing"
                                        @click="toggleShowChangePassword"
                                        class="mr-4 white--text"
                                        color="orange"
                                >
                                    Cancel
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-btn
                                        :disabled="executing"
                                        @click="$router.push('/payment')"
                                        class="mr-4 white--text"
                                        color="orange"
                                >
                                    Payment Info
                                </v-btn>

                                <v-btn
                                        :disabled="executing"
                                        @click="$router.push('/orders')"
                                        class="white--text"
                                        color="orange"
                                >
                                    My Orders
                                </v-btn>                            
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>

        <div v-if="!loggedIn">
            Login or register to view your account info.
        </div>

        <v-dialog max-width="290" persistent v-model="successDialog">
            <v-card>
                <v-card-title class="yellow white--text">Thank You</v-card-title>
                <v-card-text class="mt-5">
                    {{successMessage}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="successDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api"
    import StatesService from '../services/states-service';

    export default {
        computed: {
            executing: function () {
                return this.$store.state.executing
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            }
        },
        data() {
            return {
                showForm: true,
                formValid: true,
                showChangePassword: false,
                errorDialog: false,
                errorText: "",
                successDialog: false,
                successMessage: "",
                accountData: {
                    name: '',
                    username: '',
                    email: '',
                    mobile: '',                    
                    city: '',
                    state: '',
                    zipCode: ''
                },
                statesOptions: StatesService.getStates(),
                formRules: {
                    email: [
                        v => !!v || 'E-mail is required',
                        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ],
                    mobile: [
                        v => !!v || 'Mobile is required'
                    ],                    
                    city: [
                        v => !!v || 'City is required'
                    ],
                    state: [
                        v => !!v || 'State is required'
                    ],                    
                    zipCode: [
                        v => !!v || 'Zip is required'
                    ],
                    oldPassword: [
                        v => !!v || 'Current password is required',
                        v => (v && v.length >= 8) || 'Password must be at least 8 characters'
                    ],                    
                    newPassword: [
                        v => !!v || 'New password is required',
                        v => {
                            let error = ''
                            error += (v && v.length < 8 && 'be at least 8 characters') || ''
                            error += (!v.match("(.*)[0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one number') || ''
                            error += (!v.match("^(.*)[a-z](.*)") && ((error != '' && ', ') || '') + 'contain at least one lowercase character') || ''
                            error += (!v.match("^(.*)[A-Z](.*)") && ((error != '' && ', ') || '') + 'contain at least one uppercase character') || ''
                            error += (!v.match("(.*)[^a-zA-Z0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one symbol') || ''
                            return (error != '') ? 'Password must ' + error : true
                        }
                    ],
                    passwordConfirm: [
                        v => !!v || 'Password Confirmation is required',
                        v => v == this.accountData.newPassword || 'Password Confirmation must match'
                    ],

                },
                lazy: false,
            }
        },
        mounted()
        {
            api.get("/consumer/details").then(
            (result) => {
                this.accountData.name = result.data.name
                this.accountData.username = result.data.username
                this.accountData.email = result.data.email
                this.accountData.mobile = result.data.customer_contact?.phone
                this.accountData.city = result.data.customer_address?.city
                this.accountData.state = result.data.customer_address?.state
                this.accountData.zipCode = result.data.customer_address?.zip
            },
            (error) => {
                this.errorText = error.response.data
                this.errorDialog = true
            })

            let el = document.getElementById("mobile-field")
            if (el) el.focus()
        },
        methods: {
            toggleShowChangePassword ()
            {
                this.showChangePassword = !this.showChangePassword
            },
            keyDownHandler(k) {
                if (k.keyCode !== 13) return
                if (!this.valid) {
                    return
                }
                this.update()
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            update() {
                this.$store.dispatch("setExecuting", true)
                api.post("/profile", this.accountData).then(
                (response) => {
                    if (response &&
                        response.data.result)
                    {
                        api.post("/consumer/updateAccount", this.accountData).then(
                        () => {
                            this.showChangePassword=false
                            this.successDialog = true
                            this.successMessage = "Your profile info was successfully updated"
                        },
                        (error) => {
                            this.errorText = error.response.data
                            this.errorDialog = true
                        })
                    }
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            }
        },
    }
</script>

<style scoped>
.v-btn {
  min-width: 36px;
  font-size: 12px;
}
</style>